import {ADD_CAMPAIGN_MINIMIZE,MINUS_CAMPAIGN_MINIZE} from "../../actions/type";

const initialState=[];

export default function campaignMinimize(state=initialState,action){
    switch(action.type){
        case ADD_CAMPAIGN_MINIMIZE:
            if(state.map(it=>it.id).indexOf(action.payload.id)===-1){
                if(state.length>=8){
                    const updatedState=[...state]
                    updatedState.splice(0,1)
                    return [...updatedState,action.payload];
                }else{
                    return [...state,action.payload]
                }
            }
            return state
        case MINUS_CAMPAIGN_MINIZE:
            return [...state].filter(item=>item.id!=action.payload);
        case "clearCamMinimize":
            return []
        default:
            return state
    }
}